var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Online-Consultant"}},[_c('iframe',{attrs:{"id":"Online-Consultant-Iframe","src":`${_vm.$host}/server/kefu.php?a=621276866&fn=${_vm.user.real_name}&id=${_vm.user.certificate}`,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }